<template>
    <v-app id="solarCalcApp">
        <container class="my-auto">
            <heading  v-if="this.$storage.state.passed.length <= this.$storage.state.steps.length-2"/>
            <steps />
            <loading v-if="$storage.state.loading" />
        </container>
    </v-app>
</template>

<script>
import Container from "./components/CalcContainer";
import Heading from "./components/CalcHeading";
import Steps from "./components/Steps";
import Loading from "./components/Loading";
import { calcTotals } from "./helpers";
export default {
    name: 'App',

    components: {
        Container,
        Heading,
        Steps,
        Loading
    },
    watch:{
        '$storage.state.summary':{
            deep:true,
            handler: function(){
                if(window.wgCalc.showPrices && this.$storage.state.summary.panels.type){
                    calcTotals(this.$storage.state)
                }
            }
        }
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        let place = JSON.parse(urlParams.get("place"));
        if(place){
            this.$storage.state.place = place;
        }
    },
    data: () => ({
        //
    }),
};
</script>
<style lang="scss">
    #solarCalcApp{
    }
</style>
